/* unplugin-vue-components disabled */import script from "./MyRewardList.vue?vue&type=script&setup=true&lang=js"
export * from "./MyRewardList.vue?vue&type=script&setup=true&lang=js"

import "./MyRewardList.vue?vue&type=style&index=0&id=0a5080a8&lang=scss"

const __exports__ = script;

export default __exports__